import React,{useState, useEffect} from 'react';
import recentImage1 from './recent-image/recent-image-1.JPG';
import recentImage2 from './recent-image/recent-image-2.JPG';
import recentImage3 from './recent-image/recent-image-3.JPG';
import recentImage4 from './recent-image/recent-image-4.JPG';
import recentImage5 from './recent-image/recent-image-5.JPG';
import recentImage6 from './recent-image/recent-image-6.JPG';
import recentImage7 from './recent-image/recent-image-7.JPG';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import './recent.css';
import axios from '../axios';



 function RecentProject () {
    const [AllData, setAllData] = useState([]);
    const [Loading, setLoading] = useState(false);


const  fetchData = async () => {
    setLoading(true);
  await axios.get("/api/file")
   .then(data =>{
     setAllData(data.data)
     setLoading(false)
   })
   .catch(err => {console.log(err)
     setLoading(false);
   })
 
 }

     useEffect(()=>{
       
    fetchData();         
       },[])


    return (<div>
         <h3 className="recent_project_heading">Our Recent Projects</h3>
        <div className='home_recentproject_container '>
           
           <div className='home_recentproject recent_project_grid1'> 
            {AllData[0] ? 
             AllData[0].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[0].FileUrl}></video> 
             : <img src={AllData[0].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage1} 
            <div>
               <p>
               <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[0] ? AllData[0].Location : "Muthuthevanpatty, theni."}</p>
                   <p className="recent_project_type">{AllData[0] ? AllData[0].Service: "Construction"}</p> 
            </div> 
           </div>

{/* two */}
           <div className='home_recentproject  recent_project_grid2'> 
           {AllData[1] ? 
             AllData[1].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[1].FileUrl}></video> 
             : <img src={AllData[1].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage2} 
           <div>
                
               <p>
               <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[1] ? AllData[1].Location : "Bodinayakkanur, theni."}</p>
                   <p className="recent_project_type">{AllData[1] ? AllData[1].Service: "Plots for sales"}</p> 
            </div> 
           </div>

{/* three */}
           <div className='home_recentproject  recent_project_grid3'> 
           {AllData[2] ? 
             AllData[2].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[2].FileUrl}></video> 
             : <img src={AllData[2].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage3} 
            <div>
               <p>
                   <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[2] ? AllData[2].Location : "Aundipatti, theni."}</p>
                   <p className="recent_project_type">{AllData[2] ? AllData[2].Service: "Construction"}</p> 
            </div> 
           </div>

           <div className='home_recentproject  recent_project_grid4'> 
           {AllData[3] ? 
             AllData[3].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[3].FileUrl}></video> 
             : <img src={AllData[3].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage4} 
           <div>
             <p>
                   <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[3] ? AllData[3].Location : "Periyakulam, theni."}</p>
                   <p className="recent_project_type">{AllData[3] ? AllData[3].Service: "Plots and Approval"}</p> 
         
            </div> 
           </div>

           <div className='home_recentproject recent_project_grid5'> 
           {AllData[4] ? 
             AllData[4].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[4].FileUrl}></video> 
             : <img src={AllData[4].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage1} 
            <div>
                   
             <p>
                   <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[4] ? AllData[4].Location : "Muthuthevan patti, theni."}</p>
                   <p className="recent_project_type">{AllData[4] ? AllData[4].Service: "Plots and Approval"}</p> 
         
            </div> 
           </div>

           <div className='home_recentproject  recent_project_grid6'> 
           {AllData[5] ? 
             AllData[5].FileType === "video/mp4"  ? <video controls className="home_recent_video"  src={AllData[5].FileUrl}></video> 
             : <img src={AllData[5].FileUrl} alt="home recent image" className='recent_project_image'></img>
                 
             :  recentImage6} 
            <div>  
               <p>
                   <FontAwesomeIcon icon={faMapMarkerAlt} className="recent_map_icon" />
                   {AllData[5] ? AllData[5].Location : "Perumal Gondan patti, theni."}</p>
                   <p className="recent_project_type">{AllData[5] ? AllData[5].Service: "Construction"}</p> 
         
            </div> 
           </div>

        </div>
        </div>
    )
}

export default RecentProject